// extracted by mini-css-extract-plugin
export var collapsedSummary = "_mb-0";